import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProjectIndexListGroup from '../ProjectIndexListGroup';
import ConsultantProjectIndexRow from '../ConsultantProjectIndexRow';

const emptyEditsRequestedText = 'After you submit proposals to projects, both Clora and the employer are able to request additional information from you. When this happens, we will add them here so you can review and address the feedback.';

const emptyDraftText = 'The proposals in this section are ones that you are currently filling out, but have not submitted to Clora yet.';

class ConsultantProjectIndexContainer extends Component {
  static statusConfig(status) {
    return {
      interested: {
        groupClass: 'bg-tertiary-emphasis',
        title: 'Resume Submitted',
        useLengthForExpanded: true,
      },
      edits_requested: {
        groupClass: 'bg-warning',
        title: 'Feedback',
        useLengthForExpanded: true,
        partialEmptyTitle: 'proposals with feedback.',
        emptyText: emptyEditsRequestedText,
      },
      drafting: {
        groupClass: 'bg-default',
        title: 'Proposal Drafts',
        useLengthForExpanded: true,
        partialEmptyTitle: 'proposals that are in progress.',
        emptyText: emptyDraftText,
      },
      submitted: {
        groupClass: 'bg-accent-fallback-tertiary',
        title: 'Submitted',
        useLengthForExpanded: false,
        partialEmptyTitle: 'submitted proposals.',
      },
      awarded: {
        groupClass: 'bg-accent-primary',
        title: 'Awarded',
        useLengthForExpanded: false,
        partialEmptyTitle: 'accepted proposals.',
      },
      rejected: { groupClass: 'bg-default', title: 'Not Accepted', useLengthForExpanded: false },
    }[status];
  }

  static listGroup(projects, status) {
    const {
      groupClass,
      title,
      useLengthForExpanded,
      partialEmptyTitle,
      emptyText,
    } = ConsultantProjectIndexContainer.statusConfig(status);

    return (
      <ProjectIndexListGroup
        count={projects.length}
        classes={groupClass}
        status={status}
        title={title}
        expand={useLengthForExpanded && projects.length > 0}
      >
        {projects.map((project) => (
          <li className="list-group-item" key={project.resource_id}>
            <ConsultantProjectIndexRow
              name={project.name}
              projectLink={project.project_link}
              proposal={project.proposal}
              status={status}
              aoe={project.area_of_expertise}
              hours={project.avg_weekly_time}
              location={project.work_location}
            />
          </li>
        ))}

        {projects.length === 0 && partialEmptyTitle
          && (
          <li className="list-group-item">
            <h5 className="text-muted mb-2">
              You currently have 0
              {partialEmptyTitle}
              .
            </h5>
            {emptyText && <h6 className="text-muted">{emptyText}</h6>}
          </li>
          )}
      </ProjectIndexListGroup>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      drafting: props.projects.drafting || [],
      submitted: props.projects.submitted || [],
      edits_requested: props.projects.edits_requested || [],
      introduction: props.projects.introduction || [],
      awarded: props.projects.awarded || [],
      rejected: (props.projects.rejected || [])
        .concat(props.projects.interest_rejected || []),
      interested: (props.projects.interest_pending || [])
        .concat(props.projects.interest_approved || []),
    };
  }

  render() {
    const {
      drafting,
      submitted,
      edits_requested,
      awarded,
      rejected,
      interested,
    } = this.state;

    const proposalsExist = drafting.length || submitted.length || edits_requested.length
      || awarded.length || rejected.length;

    if (!proposalsExist && interested.length > 0) {
      return ConsultantProjectIndexContainer.listGroup(interested, 'interested');
    }

    return (
      <div>
        {interested.length > 0
          && ConsultantProjectIndexContainer.listGroup(interested, 'interested')}
        {ConsultantProjectIndexContainer.listGroup(edits_requested, 'edits_requested')}
        {ConsultantProjectIndexContainer.listGroup(drafting, 'drafting')}

        <div className="mt-50" />

        {ConsultantProjectIndexContainer.listGroup(submitted, 'submitted')}
        {ConsultantProjectIndexContainer.listGroup(awarded, 'awarded')}
        {rejected.length > 0 && ConsultantProjectIndexContainer.listGroup(rejected, 'rejected')}
      </div>
    );
  }
}

ConsultantProjectIndexContainer.propTypes = {
  projects: PropTypes.shape({
    drafting: PropTypes.arrayOf(PropTypes.shape({})),
    submitted: PropTypes.arrayOf(PropTypes.shape({})),
    edits_requested: PropTypes.arrayOf(PropTypes.shape({})),
    introduction: PropTypes.arrayOf(PropTypes.shape({})),
    awarded: PropTypes.arrayOf(PropTypes.shape({})),
    rejected: PropTypes.arrayOf(PropTypes.shape({})),
    interest_pending: PropTypes.arrayOf(PropTypes.shape({})),
    interest_approved: PropTypes.arrayOf(PropTypes.shape({})),
    interest_rejected: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

export default ConsultantProjectIndexContainer;
